import { ElementRef, Input, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { setting } from "../../../../../setting";
import { Subscription } from 'rxjs';
import CssFilterConverter from 'css-filter-converter';
import * as CryptoJS from 'crypto-js';
import { ClientSetting, SectionFooter } from '../../../interfaces/clientSetting.interface';

@Component({
  selector: 'usb-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {


  @ViewChildren('iconSocialNetworks', { read: ElementRef }) iconSocialNetworks : QueryList<ElementRef>;
  @Input() clientSetting: ClientSetting | null = null;
  // Mismo switch que HeroComponent/LoginComponent: 'classic' es el footer de siempre
  // (sin tocar), 'animated' es el nuevo estilo oscuro. Se lee directo de setting.ts acá
  // en vez de recibirlo por @Input() porque usb-footer se usa en home Y en select, y así
  // no hace falta pasarlo a mano desde cada uno.
  public variant = setting.heroVariant;
  menuHidden = true;
  public getClientsSettingAppAuth: ClientSetting | null = null;
  public sectionFooter: SectionFooter | null = null;
  public routeUploadFile:any;
  isHome: boolean = true;
  currentYear: any;
  public wsp_number: string;
  public clientSystemName: string = '';
  public filter?: any;

  public sectionFooterBackgroundImage: string = '';
  public logoPathTwo: string = '';
  public logoPathTrhee: string = '';

  private routeEventsIsHomeSubscription: Subscription;
  constructor(private router: Router) {

  }
  ngOnDestroy(): void {
    this.routeEventsIsHomeSubscription.unsubscribe();
  }

  ngOnInit() {
    this.getClientsSettingAppAuth = this.clientSetting;
    this.routeUploadFile =  setting.routeUploadFile;

    const rawSectionFooter = this.getClientsSettingAppAuth?.clients_setting_app_auth?.section_footer;
    if (typeof rawSectionFooter === 'string') {
      this.sectionFooter = JSON.parse(rawSectionFooter) as SectionFooter;
    } else {
      this.sectionFooter = (rawSectionFooter as unknown as SectionFooter) ?? null;
    }
    const wspNumber = this.getClientsSettingAppAuth?.wsp_phone_number ?? '';

    this.wsp_number = this.deleteWhitoutCharacter(wspNumber);
    this.clientSystemName = this.getClientsSettingAppAuth?.name ?? '';

    this.sectionFooterBackgroundImage = `${this.routeUploadFile}${this.sectionFooter?.background_image ?? ''}`;
    this.logoPathTwo = `${this.routeUploadFile}${this.getClientsSettingAppAuth?.logo_path_two}`;
    this.logoPathTrhee = `${this.routeUploadFile}${this.getClientsSettingAppAuth?.logo_path_three}`;

/* -----------------  change style and background by path change ---------------------------- */

this.routeEventsIsHomeSubscription = this.router.events.subscribe(event => {
  if (event instanceof NavigationEnd) {
    if (event.url === '/home') {
      this.isHome = true;
    } else if (event.url === '/select') {
      this.isHome = false;
    }
  }
});

    this.routeUploadFile =  setting.routeUploadFile;
    const date = new Date();
    this.currentYear = date.getFullYear();
    this.applyImageFilter();
  }

  deleteWhitoutCharacter(value: string): string {

    if(!value) {
      return '';
    }
    return value.replace(/\+/g, '').replace(/\s/g, '');
  }

  onLinkAbout(fragment: string) {
    const typeArticle = 'aboutUs'; // Aquí puedes configurar la variable small como necesites
    const id = 17; // Usar el índice o el id que se pase como parámetro
    const active = 0
    this.router.navigate([`/article/${typeArticle}/${id}/${this.clientSetting?.id}/${active}`], { fragment }).then(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'});
    });
  }

  articleRedirect(index: number): void {
    const typeArticle = 'segment'; // Aquí puedes configurar la variable small como necesites
    const id = index; // Usar el índice o el id que se pase como parámetro
    const active = 0
    this.router.navigate([`/article/${typeArticle}/${id}/${this.clientSetting?.id}/${active}`]).then(() => {
       window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'});
    });
  }

  onLinkSegment(nameRoute: string) {

    if(nameRoute === 'leisure') {
      this.router.navigate(['/leisure']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'wellnes') {
      this.router.navigate(['/wellnes']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'luxury') {
      this.router.navigate(['/luxury']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'mice') {
      this.router.navigate(['/mice']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'sports') {
      this.router.navigate(['/sports']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'corporative') {
      this.router.navigate(['/corporative']).then(() => {
        window.scrollTo(0, 0);
      })
    }


  }

    // Aplica un filtro de css al elemento de imagen utilizando el color seteado por cliente.
    applyImageFilter() {
      const color = this.sectionFooter?.color_icon;
      if (!color) return;
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

      //Extraemos el literal en String de la conversión
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

      // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";

      this.filter = colorFilter;

      // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
      setTimeout(() => {
        this.iconSocialNetworks.forEach(icon => {
          icon.nativeElement.setAttribute('style', `filter: ${this.filter}`);
        });
      }, 100);
    }


}
